export const REFINE_QUERY = 'search/REFINE_QUERY';

export const refineQuery = (item: { modifier?: string; operator?: string }) => {
  return {
    type: REFINE_QUERY,
    payload: {
      item,
    },
  };
};
